// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"c4e8fe21","13":"684b86a1","16":"1b230840","37":"61343f95","149":"1169e90c","318":"8b6923fe","453":"4edf87f8","456":"ba439cea","701":"2bd9cc04","762":"5008b42f","796":"b9fb53c5","939":"91a0fb66","975":"eb8e645b"}[chunkId] + ".chunk.js";
};